import { h, Component } from 'preact';

export default class Testimonials extends Component {
  render() {
    return (
      <section class="testimonials">
        <h3><span class="fa fa-microphone">&nbsp;</span> Testimonials</h3>
        <p>Want to help out? Feel free to <a href="/contact" class="underline">reach out!</a></p>

        <div class="quote">
          <p>
            Shaked is an amazing person and trainer. I worked a year with him and
            throughout that time I made an amazing friend. I had goals to meet and
            happily made them.  We had some bumps in the road with injuries,  but
            he was patient, kind and encouraging. When I was feeling down on
            myself, he knew how to lift me up and encourage me. Somedays I would
            tear up with happy tears hearing his encouraging words. His patience
            was greatly appreciated and he explained why we were taking it slow yet
            still keeping me on track.
          </p>
          <p>
            I am very lucky to have had him as my trainer and blessed to call him
            my friend.
          </p>
        </div>

        <p class="name"> Charity </p>

        <div class="quote">
          <p>
            After having two children, my lifestyle became sedentary for a couple
              of years.  On a trajectory of weight gain and less activity, I
            decided to train with Shaked two times a week for one year.  Shaked
              provided the accountability, knowledge, and consistency to support me
            in safely reaching my goals; return to a level of general fitness where
            I felt comfortable to do regular exercise like jogging, and gradual
            healthy weight loss that I was unable to do on my own after having
            children.  Additionally, Shaked helped me learn to utilize tools for
              improving my diet.  The combination of providing variety in workouts
            and plenty of positive encouragement and patience helped me gradually
            and safely build strength and endurance.  Though a secondary goal, I
            lost over 20 lbs in 8 months and achieved a level of strength I am
            satisfied to maintain several months after completion of the program.
              Shaked is an enthusiastic trainer with a good work ethic,
            sensitivity, and patience for someone starting even at beginner levels.
                I would recommend him to anyone!
          </p>
        </div>
        <p class="name"> Sara </p>

        <div class="quote">
          <p>
            Shaked has been my personal trainer for the 18 months. I highly recommend him!  He has kept me motivated and on track to achieving my long term goals. Working with him has made a huge difference in my quality of life. 
          </p>
          <p>
            Shaked has designed a custom workout program which specifically address my long term goals. We have together successfully strengthened my muscles and improved both my posture and my balance. This has made a huge difference in my life, because I am now able to walk my dog, carry my backpack, and garden to my heart's content. I am able to do these activities now in spite of the arthritis in my knees. Before I started working out with Shaked, I had had multiple sessions of physical therapy, which had only marginally addressed my issues.
          </p>
          <p>
            Shaked fine tunes each session to address what is going on with me on that day. At the beginning of the session we talk about how I am feeling and what kinds of problems I might be having. He knows that I am someone who actually would rather be almost anywhere else than a gym, so he makes the workout fun by choosing a variety of exercises. He keeps me going throughout the workout with encouraging words. The workouts are also varied to ensure that I get a whole body workout over the course of a week.
          </p>
          <p>
            Shaked pays a lot of attention to me as I am working out to make sure that I am doing each exercise with proper form and with an appropriate amount of weight or resistance. He makes sure that I am stretching. I feel very safe when working out under Shaked's supervision.
          </p>
          <p>
            Lastly, Shaked works with me to help me to arrange a schedule that works for my complicated and busy life. He encourages me to keep making the time to workout. This has been tremendously helpful to me because I have found that exercise is the best thing for me to do to counteract the stress in my life. I am currently studying about 70 hours a week and I am thriving in spite of the stress.
          </p>
        </div>

        <p class="name"> Carrie </p>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./components/testimonials.js